import { memo, MemoExoticComponent } from 'react';
import { MediaFileProps } from './media-file.types';
import { ImageFile } from './image';
import { VideoFile } from './video';
import { OtherFile } from './other';
import { ErrorWrapper, ImageOrVideoWrapper, LoaderWrapper } from '../styles';
import { InlineSpinner } from 'components/loaders';
import { HStack, Text } from 'components/ui';
import { SVG } from 'components';
import { Icons } from 'assets';

const MEDIA_FILE_COMPONENTS: Record<
  MediaFileProps['file']['type'],
  MemoExoticComponent<(props: MediaFileProps) => JSX.Element | null>
> = {
  image: ImageFile,
  video: VideoFile,
  other: OtherFile,
};

export const MediaFile = memo((props: MediaFileProps) => {
  const Component = MEDIA_FILE_COMPONENTS[props.file.type];

  const isError =
    props.file.status === 'error' || props.file.mediaStatus === 'error';

  if (props.view === 'thumbnail') {
    return (
      <ImageOrVideoWrapper>
        {props.file.mediaStatus === 'loading' && (
          <LoaderWrapper>
            <InlineSpinner
              color="black"
              style={{
                width: 24,
                height: 24,
              }}
            />
          </LoaderWrapper>
        )}

        {isError && (
          <ErrorWrapper>
            <SVG src={Icons.CrossCircle} props={{ size: '24px' }} />
          </ErrorWrapper>
        )}

        <Component {...props} />
      </ImageOrVideoWrapper>
    );
  }

  return (
    <ImageOrVideoWrapper>
      {props.file.mediaStatus === 'loading' && (
        <LoaderWrapper>
          <InlineSpinner
            color="black"
            style={{
              width: 24,
              height: 24,
            }}
          />
        </LoaderWrapper>
      )}

      {isError && (
        <ErrorWrapper>
          <HStack align="center">
            <SVG src={Icons.CrossCircle} />
            <Text>{props.file.error}</Text>
          </HStack>
        </ErrorWrapper>
      )}

      <Component {...props} />
    </ImageOrVideoWrapper>
  );
});
